import { action, thunk } from "easy-peasy";
import { fetchSecurity } from "../../services/security";

export const securityModel = {
  securities: [],
  error: null,
  setError: action((state, payload) => {
    state.error = payload;
  }),
  setSecurity: action((state, payload) => {
    state.securities = payload.sort((a, b) => a.order - b.order);
  }),
  getSecurity: thunk(async (actions, payload) => {
    try {
      const request = await fetchSecurity();
      if (request && !request.error) actions.setSecurity(request);
    } catch (err) {
      actions.setError(err);
    }
  }),
};
